import { Component, input, InputSignal, output } from "@angular/core";
import { StaticMapInput } from "src/app/shared-components/staticmap/staticmap.component";
import { InfopageHeaderComponent } from "./infopage-header/infopage-header.component";
import { PageFooterComponent } from "../../shared-components/page-footer/page-footer.component";
import { AccordionIdentity, AccordionStateClass } from "../models/accordion-state.class";
import { StaticmapComponent } from "src/app/shared-components/staticmap/staticmap.component";

@Component({
    selector: "base-infopage",
    templateUrl: "./base-infopage.component.html",
    styleUrl: "./base-infopage.component.scss",
    imports: [InfopageHeaderComponent, PageFooterComponent, StaticmapComponent],
    providers: [],
})
export class BaseInfopageComponent {
    staticMapInput: InputSignal<StaticMapInput> = input.required();
    hideSmallMap: InputSignal<boolean> = input(false);

    navigateToMap = output<void>();
}

export class BaseInfopageUnitComponent {
    accordionStateCollection: AccordionStateClass<any>[] = [];

    openSection(section: AccordionIdentity): void {
        this.accordionStateCollection.forEach((accordion) => {
            if (accordion.section() === section) {
                accordion.open();
            }
        });
    }

    goToAccordion(id: AccordionIdentity): void {
        const el = document.getElementById(id);
        this.openSection(id);
        if (el) {
            setTimeout(() => {
                el.scrollIntoView({ behavior: "smooth" });
            }, 100);
        }
    }
}
